import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Revenue',
      type: 'report-card',
      content: {
        '[]': [
          {
            '{}': {
              name: 'Current Month Revenue',
              values: {
                '[]': [
                  {
                    '{}': {
                      value: {
                        '{}': {
                          aside: 'vs. prev 1.05M',
                          quality: 'bad',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'currentMonthGlExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'revenueAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Previous Month Revenue',
              values: {
                '[]': [
                  {
                    '{}': {
                      value: {
                        '{}': {
                          aside: '',
                          quality: 'good',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'previousMonthGlExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'revenueAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Year-to-Date Revenue',
              values: {
                '[]': [
                  {
                    '{}': {
                      value: {
                        '{}': {
                          aside: '',
                          quality: 'good',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'yearToDateGlExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'revenueAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Month-Over-Month Change %',
              values: {
                '[]': [
                  {
                    '{}': {
                      value: {
                        '{}': {
                          aside: '',
                          quality: 'bad',
                          emphasis: {
                            'fmt.num': [
                              {
                                '-': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'currentMonthGlExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'revenueAmount',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'previousMonthGlExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'revenueAmount',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                  1,
                                ],
                              },
                              '%',
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      },
    },
  },
  subqueries: {
    yearToDateGlExpenses: {
      period: {
        $range: {
          end: {
            $date: '4/28/2026',
          },
          start: {
            $date: '1/1/2026',
          },
        },
      },
      target: 'ent:!gl_exp:!entry',
      selection: {
        '{}': {
          expenseAmount: {
            if: [
              [
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'Expense',
                  ],
                },
                {
                  '@.': '!amount',
                },
              ],
              0,
            ],
          },
          revenueAmount: {
            if: [
              [
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'Revenue',
                  ],
                },
                {
                  '@.': '!amount',
                },
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        costType: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!acct',
          },
          target: 'ent:!gl_accts:!acct',
          selection: {
            '@.': '!name',
          },
        },
      },
    },
    currentMonthGlExpenses: {
      period: {
        $range: {
          end: {
            $date: '4/30/2026',
          },
          start: {
            $date: '4/1/2026',
          },
        },
      },
      target: 'ent:!gl_exp:!entry',
      selection: {
        '{}': {
          expenseAmount: {
            if: [
              [
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'Expense',
                  ],
                },
                {
                  '@.': '!amount',
                },
              ],
              0,
            ],
          },
          revenueAmount: {
            if: [
              [
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'Revenue',
                  ],
                },
                {
                  '@.': '!amount',
                },
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        costType: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!acct',
          },
          target: 'ent:!gl_accts:!acct',
          selection: {
            '@.': '!name',
          },
        },
      },
    },
    previousMonthGlExpenses: {
      period: {
        $range: {
          end: {
            $date: '3/31/2026',
          },
          start: {
            $date: '3/1/2026',
          },
        },
      },
      target: 'ent:!gl_exp:!entry',
      selection: {
        '{}': {
          expenseAmount: {
            if: [
              [
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'Expense',
                  ],
                },
                {
                  '@.': '!amount',
                },
              ],
              0,
            ],
          },
          revenueAmount: {
            if: [
              [
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'Revenue',
                  ],
                },
                {
                  '@.': '!amount',
                },
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        costType: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!acct',
          },
          target: 'ent:!gl_accts:!acct',
          selection: {
            '@.': '!name',
          },
        },
      },
    },
  },
}
